module.exports = __webpack_public_path__ + "static/media/affilatedBanner.7a510449.svg";